export default __webpack_public_path__ + "static/media/1.4ad4088a.png";